export interface ParsedCommentsFilterKeywords {
  afterDate: Date | null
  reviewId: number | null
  id: string | null
  isResolved: boolean | null
  remainingText: string
}

/**
 * Parses the below keywords from filter text.
 * -  `after:YYYY-MM-DD` to filter comments created after a specific date.
 * -  `review-id:NUMBER` to filter comments by a specific review ID.
 * -  `id:VALUE` to filter comments by a specific comment or thread ID.
 * -  `is:resolved` or `is:unresolved` to filter by resolution status.
 *
 * Returns parsed keywords and any remaining text for free-text matching.
 */
export function parseFilterKeywords(filterText: string): ParsedCommentsFilterKeywords {
  const afterMatch = filterText.match(/(^|\s)after:(\S+)/i)
  let afterDate: Date | null = null
  let reviewId: number | null = null
  let id: string | null = null
  let isResolved: boolean | null = null

  const isResolvedMatch = filterText.match(/(^|\s)is:(resolved|unresolved)(?=\s|$)/i)
  if (isResolvedMatch?.[2]) {
    isResolved = isResolvedMatch[2].toLowerCase() === 'resolved'
  }
  const reviewIdMatch = filterText.match(/(^|\s)review-id:(\d+)(?=\s|$)/i)
  if (reviewIdMatch?.[2]) {
    reviewId = parseInt(reviewIdMatch[2], 10)
  }
  const idMatch = filterText.match(/(^|\s)id:(\S+)(?=\s|$)/i)
  if (idMatch?.[2]) {
    id = idMatch[2]
  }

  if (afterMatch?.[2]) {
    const parsed = new Date(afterMatch[2])
    if (!isNaN(parsed.getTime())) {
      afterDate = parsed
    }
  }

  const remainingText = filterText
    .replace(/(^|\s)after:\S*/gi, '$1')
    .replace(/(^|\s)review-id:\S*/gi, '$1')
    .replace(/(^|\s)id:\S*/gi, '$1')
    .replace(/(^|\s)is:(resolved|unresolved)/gi, '$1')
    .trim()

  return {afterDate, reviewId, id, isResolved, remainingText}
}
